import { default as mainMenu } from "./modules/_main-menu.js";
import { default as scroll } from "./base/_scroll.js";
import { default as accordions } from './modules/_accordions.js';
import { default as forms } from "./modules/_forms.js";
import { default as loadMore } from "./modules/_load-more.js";
import { default as modals } from "./modules/_modals.js";
import { default as notice } from "./modules/_notice.js";
import { default as timeline } from "./modules/_timeline.js";
import { default as bubbles } from "./modules/_bubbles.js";

(function () {
  mainMenu.init();
  scroll.init();
  accordions.init();
  forms.init();
  loadMore.init();
  modals.init();
  notice.init();
  timeline.init();
  bubbles.init();
})();
